import React from 'react';

type DeletedUser = {
  dfn: string;
  deletedUser: string;
};

export function DeletedUser({ dfn, deletedUser }: DeletedUser) {
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      <strong className="font-bold-15-19">{deletedUser}</strong>
    </p>
  );
}
